import { atom } from "jotai";
import { cursorAtom } from "./cursorAtom";
import { isViewOnlyModeAtom } from "../permissions";
import { isDraftModeIncludingTemplatesAtom } from "../nodes";

export const shouldShowAddStepButtonAtom = atom((get) => {
  const cursorMode = get(cursorAtom);
  const isViewOnlyMode = get(isViewOnlyModeAtom);
  const isDraftModeIncludingTemplates = get(isDraftModeIncludingTemplatesAtom);

  return (
    cursorMode !== "connect" &&
    !isViewOnlyMode &&
    !isDraftModeIncludingTemplates
  );
});

shouldShowAddStepButtonAtom.debugLabel = "shouldShowAddStepButtonAtom";
